// ListGuesser
import { useState, useEffect } from 'react';
import {Admin, Resource} from 'react-admin';
import authProvider from './authProvider';
import dataProvider from './dataProvider';
import {CustomLoginPage} from './CustomLoginPage';
import {UserList} from './lists/UserList';
import {RolesList} from "./lists/RolesList";
import {UserItem} from './lists/UserItem';
import {TravelList} from "./lists/TravelList";


const App = () => {
    const [isAuthChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        authProvider
            .checkAuth()
            .catch(() => {
            }) // intentionally ignored, we just want to detect state
            .finally(() => setAuthChecked(true));
    }, []);

    if (!isAuthChecked) return <div>Загрузка...</div>;

    return (
        <Admin
            loginPage={CustomLoginPage}
            authProvider={authProvider}
            dataProvider={dataProvider}
        >
            <Resource
                name="users"
                list={UserList}
                options={{label: 'Пользователи'}}
                show={UserItem}
            />

            <Resource
                name="v1/admin/roles"
                list={<RolesList filter={{fields: 'user'}}/>}
                options={{label: 'Роли'}}
            />

            <Resource
                name="travels"
                list={TravelList}
                options={{ label: 'Путешествия' }}
            />
        </Admin>
    );
}

export default App;
